'use es6';

import * as SurveyTypes from 'feedback-schema/constants/surveyTypes';
import * as SurveyStages from 'feedback-schema/constants/surveyStages';
import * as PopupStyles from 'feedback-schema/constants/surveyProperties/popupStyles';
import * as Style from '../popupInjector/style';
const ADDITIONAL_WIDTH = 24;
export const getWidthForStage = (stage, config, popup, isPreview) => {
  const {
    embedStyle,
    surveyType
  } = config || {};
  if (stage === SurveyStages.CALLOUT && !isPreview) {
    popup.style.width = `${Style.CALLOUT_MAX_WIDTH}px`;
    const page = popup.querySelector('.page');
    if (page) {
      const newWidth = Math.min(page.scrollWidth + ADDITIONAL_WIDTH, Style.CALLOUT_MAX_WIDTH);
      popup.style.width = null;
      return newWidth;
    }
  }
  if ((stage === SurveyStages.FOLLOW_UP || stage === SurveyStages.THANK_YOU) && surveyType === SurveyTypes.CSAT && embedStyle !== PopupStyles.POPUP_TOP) {
    return Style.EXTENDED_CSAT_WIDTH;
  }
  return null;
};